export const services = {
  pageTitle: 'Onze Diensten',
  pageSubtitle: 'Volledige oplossingen voor al uw renovatie- en bouwprojecten in Brussel',
  
  // Masonry
  masonryTitle: 'Metselwerk',
  masonryDescription: 'Solide en duurzame metselwerken om uw vastgoed te beveiligen en op te waarderen',
  masonryFeature1: 'Bouw van dragende muren',
  masonryFeature2: 'Gevelreparaties',
  masonryFeature3: 'Funderingen en vloerplaten',
  masonryFeature4: 'Metselwerken',
  
  // Bathroom & Kitchen
  bathroomTitle: 'Badkamer & Keuken',
  bathroomDescription: 'Moderne, functionele en esthetische ruimtes, ontworpen voor uw dagelijks comfort',
  bathroomFeature1: 'Volledige renovatie',
  bathroomFeature2: 'Sanitaire installatie',
  bathroomFeature3: 'Tegels en bekledingen',
  bathroomFeature4: 'Inrichting op maat',
  
  // Painting & Finishes
  paintingTitle: 'Schilderwerken & Afwerking',
  paintingDescription: 'Verzorgde afwerkingen die uw ruimtes sublimeren en een onberispelijk resultaat garanderen in de tijd',
  paintingFeature1: 'Binnen- en buitenschilderwerk',
  paintingFeature2: 'Voorbereiding van oppervlakken',
  paintingFeature3: 'Behangwerken',
  paintingFeature4: 'Decoratieve afwerkingen',
  
  // Partitions & Insulation
  partitionTitle: 'Scheidingswanden & Isolatie',
  partitionDescription: 'Performante isolatie om uw thermisch comfort te verbeteren en uw energiekosten te verlagen',
  partitionFeature1: 'Gipsplaten scheidingswanden',
  partitionFeature2: 'Thermische isolatie',
  partitionFeature3: 'Akoestische isolatie',
  partitionFeature4: 'Ruimte-inrichting',
  
  // Carpentry
  carpentryTitle: 'Schrijnwerk',
  carpentryDescription: 'Installatie en renovatie van deuren, ramen en inrichtingen op maat met ambachtelijk vakmanschap',
  carpentryFeature1: 'Binnen- en buitendeuren',
  carpentryFeature2: 'Ramen en kozijnen',
  carpentryFeature3: 'Parket en vloerbedekking',
  carpentryFeature4: 'Inrichtingen op maat',
  
  // Electrical
  electricalTitle: 'Elektriciteit',
  electricalDescription: 'Elektrische installaties conform de Belgische normen voor uw veiligheid en gemoedsrust',
  electricalFeature1: 'Volledige elektrische installatie',
  electricalFeature2: 'Normering',
  electricalFeature3: 'Verlichting en domotica',
  electricalFeature4: 'Herstelling en onderhoud',
  
  // CTA
  ctaTitle: 'Heeft u een offerte nodig voor uw project?',
  ctaDescription: 'Neem contact met ons op om uw project te bespreken en een gratis en gepersonaliseerde offerte te ontvangen',
  ctaButton: 'Vraag een gratis offerte aan'
};
